module.exports = __webpack_public_path__ + "static/richard1-f1fc3a88ca30ce4985a4af5e6d1b5f45.png";